import { ErrorConfig, UNAUTHORIZED_FALLBACK_MESSAGE } from '@/lib/http-client';

export function isErrorConfig(error: ErrorConfig | unknown): error is ErrorConfig {
	return (
		!!error &&
		typeof error === 'object' &&
		(error as ErrorConfig).code !== undefined &&
		(error as ErrorConfig).message !== undefined
	);
}

export function getErrorDisplayMessage(error: ErrorConfig | unknown) {
	if (isErrorConfig(error) && error.message) {
		return error.message;
	}

	if (typeof error === 'string' && error) {
		return error;
	}

	if ((error as Error)?.message) {
		return (error as Error).message;
	}

	if ((error as { status?: number })?.status === 403) {
		return UNAUTHORIZED_FALLBACK_MESSAGE;
	}

	return 'Sorry, an error occurred.';
}

export function isAskHackettAuthorizationRoute(pathname: string) {
	return pathname === '/ask-hackett' || pathname.startsWith('/report/ai-conversation');
}

export function isAskHackettApiError(error: ErrorConfig | unknown) {
	if (!isErrorConfig(error)) {
		return false;
	}

	const requestUrl = error.requestUrl ?? error.axiosError?.config?.url ?? '';

	return [
		'/advisory-service/api/v1/ai-conversation',
		'/advisory-service/api/v1/ai-conversations',
		'/advisory-service/api/v1/ai-project',
		'/advisory-service/api/v1/ai-projects',
		'/advisory-service/api/v1/public/ai-conversation/stream',
		'/advisory-service/api/v1/report/ai-conversation',
	].some((path) => requestUrl.includes(path));
}

export function shouldRedirectAskHackettAuthorization(error: ErrorConfig | unknown, pathname: string) {
	return isAskHackettAuthorizationRoute(pathname) || isAskHackettApiError(error);
}
